var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('i',{staticClass:"empty-icon fa fa-exclamation-circle"}),_c('div',{staticClass:"empty-text"},[_vm._t("default")],2),_c('a-button',{attrs:{"to":_vm.to,"theme":"purple","text":_vm.button}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }